import { Component, inject } from "@angular/core";
import {
  AlertButton,
  AlertService,
  ConfirmationAlert,
} from "../alert/alert.service";

@Component({
  standalone: false,
  selector: "app-alert-v2",
  templateUrl: "./alert-v2.component.html",
  styleUrls: ["./alert-v2.component.scss"],
})
export class AlertV2Component {

  private readonly alertService = inject(AlertService);  showAlert = false;
  size = "modal-md";
  showFooter = false;
  title = "";
  loading = false;
  body = "";
  title_icon: string | null = null;
  title_color = "";
  syncing = false;
  disableClose = false;
  iconCheck = 'check_circle';
  iconTimesCircle = 'cancel';
  buttons: AlertButton[] = [];

  setConfirmAlertData(data: ConfirmationAlert): void {
    this.size = "modal-md";
    this.title = data.title;
    this.body = data.body;
    this.disableClose = !!data.disableClose;
    this.buttons = [];
    if (!data.hideCancel) {
      this.buttons.push({
        title: data.cancelLabel || "Cancelar",
        btn_class: "btn-default",
        onClick: () => { this.closeAlert(data.onClose); },
        focus: false,
      });
    }
    if (data.secondaryLabel) {
      this.buttons.push({
        title: data.secondaryLabel,
        btn_class: "btn-warning",
        onClick: () => {
          if (data.onSecondaryAction) {
            this.syncing = true;
            data.onSecondaryAction();
          }
        },
        focus: false,
      });
    }
    this.buttons.push({
      title: data.confirmLabel,
      btn_class: data.confirmDanger ? "btn-danger" : "btn-primary",
      onClick: () => {
        if (data.onConfirm) {
          this.syncing = true;
          data.onConfirm();
        }
      },
      focus: data.confirmFocus || false,
    });
    this.showFooter = true;
    this.showAlert = true;
  }

  closeAlert(onClose?: any, forceClose: boolean = false): void {
    if ((!this.syncing && !this.disableClose) || forceClose) {
      if (onClose) onClose();
      this.resetAlert();
    }
  }

  resetAlert(): void {
    this.size = "modal-md";
    this.showFooter = false;
    this.title = "";
    this.loading = false;
    this.body = "";
    this.title_icon = null;
    this.title_color = "";
    this.buttons = [];
    this.syncing = false;
    this.disableClose = false;
    this.showAlert = false;
  }

  onClose(): void {
    this.closeAlert();
  }
}
